/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N6Inputs */

const en_formatter_ref_n6 = /** @type {(inputs: Formatter_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond 2^53 the value itself changes. This is the one lossy case.`)
};

const ko_formatter_ref_n6 = /** @type {(inputs: Formatter_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2^53을 넘으면 값 자체가 바뀝니다. 유일하게 손실이 발생하는 경우입니다.`)
};

const ja_formatter_ref_n6 = /** @type {(inputs: Formatter_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2^53 を超えると値そのものが変わります。唯一の損失があるケースです。`)
};

/**
* | output |
* | --- |
* | "Beyond 2^53 the value itself changes. This is the one lossy case." |
*
* @param {Formatter_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n6 = /** @type {((inputs?: Formatter_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n6(inputs)
	if (locale === "ko") return ko_formatter_ref_n6(inputs)
	return ja_formatter_ref_n6(inputs)
});